import { FilterButton } from '../FilterButton';
import { typeFilters } from 'pages/LienKetVung/constants';
import Accordion from 'components/Accordion';
import { useState } from 'react';
import { PageFilterCard } from 'components/FilterCard';

import './styles.scss';

export const Filters = ({
  filterList,
  onChangeFilters,
  handleShowAllFilters,
  handleHideAllFilters,
}) => {
  const isDesktop = window.innerWidth > 768;
  const handleChangeFilters = (e) => {
    const { id, type } = e.currentTarget.dataset;
    return onChangeFilters(id, type);
  };

  // if (isDesktop)
  return (
    // <CollapsibleCard
    //   className="filter-card"
    //   defaultCollapsed={false}
    //   arrowPosition="top"
    // >
    //   <CollapsibleCard.Content>
    //     <Content
    //       currentFilters={filterList}
    //       handleChangeFilters={handleChangeFilters}
    //       onShowAll={handleShowAllFilters}
    //       onHideAll={handleHideAllFilters}
    //       isDesktop={true}
    //     />
    //   </CollapsibleCard.Content>
    //   <CollapsibleCard.Header />
    // </CollapsibleCard>
    <PageFilterCard>
      <Content
        currentFilters={filterList}
        handleChangeFilters={handleChangeFilters}
        onShowAll={handleShowAllFilters}
        onHideAll={handleHideAllFilters}
        isDesktop={isDesktop}
      />
    </PageFilterCard>
  );
};

const Content = ({
  currentFilters,
  handleChangeFilters,
  onShowAll,
  onHideAll,
  isDesktop = false,
}) => {
  const amenitiesItems = typeFilters['tien-ich'] || [];
  const transportationItems = typeFilters['giao-thong'] || [];
  const [accordionValue, setAccordionValue] = useState(['item-1']);

  const { 'tien-ich': tienIchFilters } = currentFilters;

  const isTienIchAllSelected = tienIchFilters.length === amenitiesItems.length;

  return (
    <div className="accordion-wrapper">
      <Accordion
        className="filter-accordion"
        type="multiple"
        value={isDesktop ? accordionValue : ['item-1', 'item-2']}
        onValueChange={setAccordionValue}
      >
        <Accordion.Item value="item-1">
          <Accordion.Trigger>Tất cả tiện ích</Accordion.Trigger>
          <Accordion.Content>
            {amenitiesItems.map((filter) => {
              const Icon = filter.icon;
              const isActive = currentFilters['tien-ich'].includes(filter.id);
              return (
                <FilterButton
                  type={'tien-ich'}
                  id={filter.id}
                  key={filter.id}
                  label={filter.label}
                  icon={<Icon color={isActive ? '#F0B619' : '#737373'} />}
                  onChangeFilter={handleChangeFilters}
                  isActive={isActive}
                />
              );
            })}
          </Accordion.Content>
        </Accordion.Item>

        <Accordion.Item value="item-2">
          <Accordion.Trigger>Tất cả giao thông</Accordion.Trigger>
          <Accordion.Content>
            {transportationItems.map((filter) => {
              const Icon = filter.icon;
              const isActive = currentFilters['giao-thong'].includes(filter.id);
              return (
                <FilterButton
                  type={'giao-thong'}
                  id={filter.id}
                  key={filter.id}
                  label={filter.label}
                  icon={<Icon color={isActive ? '#F0B619' : '#737373'} />}
                  onChangeFilter={handleChangeFilters}
                  isActive={isActive}
                />
              );
            })}
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
      <div className="button-container">
        <button onClick={isTienIchAllSelected ? onHideAll : onShowAll}>
          {isTienIchAllSelected ? 'Ẩn tất cả tiện ích' : 'Hiện tất cả tiện ích'}
        </button>
      </div>
    </div>
  );
};
